import { Component } from '@angular/core';
import { VitaminDSupplementComponent } from '@consultation-upsells/vitamin-d-supplement/vitamin-d-supplement.component';

@Component({
  selector: 'app-vitamin-d-supplement-peptide',
  imports: [VitaminDSupplementComponent],
  templateUrl: './vitamin-d-supplement-peptide.component.html',
})
export class VitaminDSupplementPeptideComponent {}
